import React, { useEffect, useState, useLayoutEffect, useImperativeHandle, useContext } from "react";
import { Container, Col, Row } from "react-bootstrap";
import URLstateContext from "../../../provider/CommonContext";
import { useLocation, useParams, useNavigate, Link } from "react-router-dom";
import { Vortex } from 'react-loader-spinner'

function MfRatios(props) {
    let getMFCode = props.MFcode;
    const [data, setData] = useState([]);
    const { BaseURL } = useContext(URLstateContext);
    const [loadingshow, setloadingshow] = useState(false);
    let getData;
    useEffect(() => {
        setloadingshow(true);
        if (getMFCode != '') {
            const getUrl = BaseURL + "MfRatios";
            fetch(`${getUrl}/${getMFCode}`)
                .then((response) => response.json())
                .then((data) => {
                    getData = data.data;
                    // console.log(getData)
                    setData(getData);
                    setloadingshow(false);
                })
                .catch((error) => {
                    // console.log("not found the api 1233333");
                });
        }
    }, [getMFCode]);
    return (
        <>
            <section className="peer-sc">
                <div className='container table-boxpeerMutual'>
                    <div className='row'>
                        <div className='col-md-12'>
                            <h3 className="mainHeadingGroup">Statistical Ratios</h3>
                            <div className="table-responsive">
                                <table className="table table-sm table-striped table-bordered table-hover">

                                    <thead className='heading'>
                                        <tr>
                                            <th scope="col">Scheme Name</th>
                                            <th scope="col">Beta(%)</th>
                                            <th scope="col">Sd</th>
                                            <th>Sharepe Ratio(%)</th>
                                            <th>Jensons Alpha(%)</th>
                                            <th>Tr(%)</th>
                                        </tr>
                                    </thead>
                                    {(data === null) ? <div className="errorMsg"><h3>No Data Found !!!</h3></div> : ''}
                                    <tbody>

                                        {data != null && data.map(({ SCHEME_NAM,BETA,SD,SHARPE,TREYNOR,ALPHA}) => (
                                            <tr className="SameCompPeer ">
                                                <td>{SCHEME_NAM} </td>
                                                <td>{BETA != null ? BETA.toFixed(2) : 0} </td>
                                                <td>{SD != null ? SD.toFixed(2) : 0} </td>
                                                <td>{SHARPE != null ? SHARPE.toFixed(2) : 0} </td>
                                                <td>{ALPHA != null ? ALPHA.toFixed(2) : 0} </td>
                                                <td>{TREYNOR != null ? TREYNOR.toFixed(2) : 0} </td>
                                            </tr>

                                        ))}
                                    </tbody>
                                </table>
                                {loadingshow ? <div className="textcentervertex">
                                                        <Vortex
                                                            visible={true}
                                                            height="80"
                                                            width="80"
                                                            ariaLabel="vortex-loading"
                                                            wrapperStyle={{}}
                                                            wrapperClass="vortex-wrapper"
                                                            colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                                        />
                                                        <div className="model_popup">Please Wait...</div>
                                                    </div> : ""
                                                    }
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default MfRatios